import React from 'react';
import QueryLoader from '../Loaders/QueryLoader';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export const PG_ERROR_URL = `${process.env.MONOLITH_HOST_URL}/500`;

class ErrorBoundary extends React.PureComponent<Props, State> {
  // getDerivedStateFromError along with hasError state is boilerplate from the React docs
  // https://reactjs.org/docs/error-boundaries.html
  // we can change this to fit our liking
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props: Props) {
    super(props);

    this.state = { hasError: false };
  }

  // A future ticket (https://policygenius.atlassian.net/browse/WINNE-2740)
  // will hanlde integrating Datadog RUM observability into this ErrorBoundary
  componentDidCatch(): void {
    // Redirect to the generic 500 page for now
    // We can customize this based on the error in the future
    window.location.assign(PG_ERROR_URL);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      // Return a loader so that the page isn't blank
      return <QueryLoader />;
    }

    return children;
  }
}

export default ErrorBoundary;
